/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toUnreadProps } from './translator/unread'
import { GetUnread } from '@/infrastructure/network/Monitaro/requests/notification'

export default class Notification extends MonitaroGatewayBase {
  async GetUnread() {
    const { unread } = await this.apiClient.request(new GetUnread())
    return toUnreadProps(unread)
  }
}
